var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DocumentUpload"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileSelected}}),_c('button',{on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.$t('upload-button')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }